<template>
  <not-authenticated>
    <v-card
      class="elevation-0 mx-auto login-area-box"
      color="transparent"
      flat>
      <loading />
    </v-card>
  </not-authenticated>
</template>

<script>
  const NotAuthenticated = () => import('@/components/NotAuthenticated')
  const Loading = () => import('@/components/ui/Loading')

  export default {
    name: 'Login',
    components: {
      NotAuthenticated,
      Loading
    },
    beforeMount () {
      this.$store.commit('app/loading', true)
      const token = this.$route.query.token || this.$route.params.pathMatch.slice(1)

      this
        .$store
        .dispatch('app/auth', token)
        .then(access => {
          this.$store.commit('app/loading', true)
          this.$router.push({ name: 'Case', params: { caseId: access.caseId } })
        })
        .catch((error) => {
          this.errorLogin(error)
          this.isLoading = false
          this.validLogin = !this.isLoading
        })
    },
    methods: {
      errorLogin () {
        this.$root.$emit('snackbar', {show: true, color: 'error', text: 'Erro no Login, confira seus dados'})
      },
      _setUserToRaven () {
        // Confirmar se o groups está passando
        // Raven.setUserContext({
        //   email: user.email,
        //   id: user.id,
        //   groups: user.groups
        // })
      }
    }
  }
</script>
